<div class="business-overdraft-documents-component">
  <document-details
    [application]="application"
    [apiUrl]="apiUrl"
    (scrollEvent)="scrollToChildTwo()"
    [listApplicationDocumentFn]="listApplicationDocumentFn"
    [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
    [approveApplicationDocumentFn]="approveApplicationDocumentFn"
    [declineApplicationDocumentFn]="declineApplicationDocumentFn"
    [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
    [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
    [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
    [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
     
    [createDocumentWorklistFn]="createDocumentWorklistFn"
    [completeDocumentWorklistFn]="completeDocumentWorklistFn"
    [generateApprovalNoticeFn]="generateApprovalNoticeFn"
    [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
    [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
    [businessLoanData]="data"
    [undoApplicationDocumentFn]="undoApplicationDocumentFn"
    [getUserFn]="getUserFn"
    [getUserByAccessLevelFn]="getUserByAccessLevelFn"
    (events)="onDocumentDetailsEvent($event)"
    (saveNote)="onSaveNote()"
    [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
    [settleLoanFn]="settleLoanFn"
    [updateApplicationStageFn]="updateApplicationStageFn"
    [getApplicationAssetFn]="getApplicationAssetFn"
    [getApplicationByIdFn]="getApplicationByIdFn"
    [updateApplicationStageFn]="updateApplicationStageFn"
    [totalNotesCount]="totalNotesCount"
  ></document-details>

  <div class="notes">
    <asset-notes
      #assetNotesComponent
      [application]="application"
      [createDocumentWorklistFn]="createDocumentWorklistFn"
      [completeDocumentWorklistFn]="completeDocumentWorklistFn"
      [isAssetNoteEditorShow] = "false"
      [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
      [createApplicationNoteFn]="createApplicationNoteFn"
      [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
      (totalNotesEvent)="totalNotes($event)"
    ></asset-notes>
  </div>
</div>
